import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Tiers from "@/components/Tiers";
import Testimonials from "@/components/Testimonials";
import CoachBio from "@/components/CoachBio";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import InstagramFeed from "@/components/InstagramFeed";
import Footer from "@/components/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-[#08080A] font-body text-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Marquee gold />
        <Tiers />
        <Testimonials />
        <CoachBio />
        <Faq />
        <Contact />
        <InstagramFeed />
      </main>
      <Footer />
    </div>
  );
}
